/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.2
 */

export const isLinkExternal = (link: string): boolean => {
    return link.startsWith('http');
};
